/**
 * J08 v1 — Paleta fixa de cores para chips de categoria de termos
 * monitorados. Decisao: hash determinístico do nome da categoria mapeia
 * para um dos 8 slots da paleta. Isso garante que "Cliente" sempre tem
 * a mesma cor em qualquer tela, sem precisar persistir a cor no banco.
 *
 * Categorias sem nome (null) caem num cinza neutro.
 *
 * Paleta usa as cores semanticas do Tailwind v4 com mix nas variaveis
 * CSS do tema (suportadas tanto no light quanto no dark mode).
 */

const PALETTE: ReadonlyArray<string> = [
  // emerald
  'bg-emerald-500/15 text-emerald-500 ring-1 ring-emerald-500/30',
  // sky
  'bg-sky-500/15 text-sky-500 ring-1 ring-sky-500/30',
  // amber
  'bg-amber-500/15 text-amber-500 ring-1 ring-amber-500/30',
  // violet
  'bg-violet-500/15 text-violet-500 ring-1 ring-violet-500/30',
  // rose
  'bg-rose-500/15 text-rose-500 ring-1 ring-rose-500/30',
  // teal
  'bg-teal-500/15 text-teal-500 ring-1 ring-teal-500/30',
  // fuchsia
  'bg-fuchsia-500/15 text-fuchsia-500 ring-1 ring-fuchsia-500/30',
  // orange
  'bg-orange-500/15 text-orange-500 ring-1 ring-orange-500/30',
];

const NEUTRAL = 'bg-zinc-500/15 text-zinc-400 ring-1 ring-zinc-500/30';

/**
 * djb2 hash simplificado — suficiente para distribuir uns 20-50 nomes
 * de categoria em 8 buckets sem colisao perceptivel.
 */
function hash(s: string): number {
  let h = 5381;
  for (let i = 0; i < s.length; i++) {
    h = (h * 33) ^ s.charCodeAt(i);
  }
  return h >>> 0;
}

export function categoryColorClasses(category: string | null | undefined): string {
  if (!category || !category.trim()) return NEUTRAL;
  const idx = hash(category.toLowerCase().trim()) % PALETTE.length;
  return PALETTE[idx] ?? NEUTRAL;
}
